import { FC } from "react";
import Header from "../../../components/layout/Header";
import PublisherForm from "../../../components/system/publisher/PublisherForm";
import { useTranslation } from "react-i18next";

const SystemPublisherCreate: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="content-wrapper">
      <Header
        iconFile="icon-system-big.svg"
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.publisher.11')}
      />
      <PublisherForm />
    </div>
  );
};

export default SystemPublisherCreate;